export class AttributeOption {

    public id: number;

    public clazz?: string = "com.qpp.cgp.domain.attribute.AttributeOption";

    public createdDate?: number;

    public createdBy?: string;

    public modifiedDate?: number;

    public modifiedBy?: string;

    public name: string;

    public sortOrder: number;

    public imageUrl?: string;

    public value: string;

    public displayValue: string;
    
    public isSelected: boolean;

    public attributeId ?: number;

    public multilingualKey ?: string = "com.qpp.cgp.domain.attribute.AttributeOption";
}